<template>
  <div class="app-copyright-model">
    <p>Copyright © 2025 广州市济帆生物科技有限公司 版权所有 粤网药信备字(2025)第00042号</p>
  </div>
</template>
<script>
  export default {
    name: 'app-copyright'
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .app-copyright-model {
    height: 28px;
    line-height: 26px;
    p {
      font-size: 12px;
      color: #888;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/copyright.vue